import { gql } from '@apollo/client';

export const HUBS = gql`
  query Hubs($data: HubParamsInput!) {
    hubs(data: $data) {
      results {
        id
        name
        position {
          lat
          lng
        }
        hubType
        address {
          formattedAddress
          streetName
          streetNumber
          city
          postalCode
          region
          countryCode
        }
        timeZoneId
        active
        currencyCode
        measurementSystem
        minBookWindowHours
        details {
          code
          name
          value
        }
        geographicArea {
          lat
          lng
        }
      }
      pagination {
        currentPage
        pageSize
        totalPages
        totalResults
      }
    }
    countries {
      code
      displayName
    }
  }
`;

export const HUB = gql`
  query Hub($id: Int!) {
    hub(id: $id) {
     id
     name
     position {
       lat
       lng
     }
     hubType
     address {
       formattedAddress
       streetName
       streetNumber
       city
       postalCode
       region
       countryCode
     }
     timeZoneId
     active
     currencyCode
     measurementSystem
     minBookWindowHours
     details {
       code
       name
       value
     }
     geographicArea {
       lat
       lng
     } 
    }
  }
`;

export const HUB_DETAIL_LIST = gql`
  query HubDetails($id: Int!) {
    hubDetails(id: $id) {
      code
      value
      name
    }
  }
`;

export const RADIUSES = gql`
  query Radiuses($id: Int!) {
    hubRadiuses(id: $id) {
      id
      name
      radiusStart
      radiusEnd
    }
    hub(id: $id) {
      id
      currencyCode
      measurementSystem
    }
  }
`;

export const HUB_ADDON_FARE_LIST = gql`
  query HubAddonFares($id: Int!) {
    hubAddonFares(id: $id) {
      id
      hubId
      addon
      vehicleCategories
      price
    }
  }
`;

export const HUB_BOOKING_WINDOW_OVERRIDES = gql`
  query HubBookingWindowOverrides($hubId: Int!) {
    hubBookingWindowOverrides(hubId: $hubId) {
      id
      created
      updated
      hubId
      vehicleConfigurationId
      minBookWindowHours
      days
      timeFrom
      timeTo
    }
  }
`;

export const VEHICLE_CONFIGURATION_BOOKING_WINDOW_OVERRIDES = gql`
  query VehicleConfigurationBookingWindowOverrides($vehicleConfigurationId: Int!) {
    vehicleConfigurationBookingWindowOverrides(vehicleConfigurationId: $vehicleConfigurationId) {
      id
      created
      updated
      hubId
      vehicleConfigurationId
      minBookWindowHours
      days
      timeFrom
      timeTo
    }
  }
`;

export const REMOVE_BOOKING_WINDOW_OVERRIDE = gql`
  mutation RemoveBookingWindowOverride($id: Int!) {
    removeBookingWindowOverride(id: $id)
  }
`;

export const UPDATE_BOOKING_WINDOW_OVERRIDE = gql`
  mutation UpdateBookingWindowOverride($data: BookingWindowOverrideParams) {
    updateBookingWindowOverride(data: $data)
  }
`;

export const CREATE_BOOKING_WINDOW_OVERRIDE = gql`
  mutation CreateBookingWindowOverride($data: BookingWindowOverrideParams) {
    createBookingWindowOverride(data: $data)
  }
`;

export const REMOVE_HUB_DETAIL = gql`
  mutation RemoveHubDetail($hubId: Int!, $code: String!) {
    removeHubDetail(hubId: $hubId, code: $code)
  }
`;

export const CREATE_HUB_DETAIL = gql`
  mutation CreateHubDetail($hubId: Int!, $code: String!, $value: String!) {
    createHubDetail(hubId: $hubId, code: $code, value: $value) {
      code
      value
      name
    }
  }
`;

export const CREATE_HUB = gql`
  mutation CreateHub($data: HubParams!) {
    createHub(data: $data) {
      id
      name
    }
  }
`;

export const UPDATE_HUB_DETAIL = gql`
  mutation UpdateHubDetail($hubId: Int!, $code: String!, $value: String!) {
    updateHubDetail(hubId: $hubId, code: $code, value: $value) {
      code
      value
      name
    }
  }
`;

export const HUB_DESTINATION_MANAGERS = gql`
  query HubDestinationManagers {
    hubDestinationManagers {
      id
      name
      email
    }
  }
`;

export const HUB_INFORMATION = gql`
  query HubDetails($id: Int!) {
    hub(id: $id) {
      id
      name
      position {
        lat
        lng
      }
      hubType
      address {
        formattedAddress
        streetName
        streetNumber
        city
        postalCode
        region
        countryCode
      }
      timeZoneId
      active
      currencyCode
      measurementSystem
      minBookWindowHours
      bufferTimeDomesticInbound
      bufferTimeDomesticOutbound
      bufferTimeInternationalInbound
      bufferTimeInternationalOutbound
      managedByUserId
      vatLevel
      geographicArea {
        lat
        lng
      }
      autoCompleteName
      autoCompleteLocation
      overrideJourneysDistributionDefaultPercentages
    }
    countries {
      code
      displayName
    }
    timeZones {
      id
      displayName
      rawOffset
      observesDaylightTime
      useDaylightTime
      currentOffset
    }
    currencies
    destinationManagers {
      id
      name
    }
  }
`;

export const UPDATE_HUB_INFORMATION = gql`
  mutation UpdateHubInformation($data: HubUpdateInput) {
    updateHubInformation(data: $data)
  }
`;

export const DEACTIVATE_HUB = gql`
  mutation DeactivateHub($id: Int!) {
    deactivateHub(id: $id)
  }
`;

export const ACTIVATE_HUB = gql`
  mutation ActivateHub($id: Int!) {
    activateHub(id: $id)
  }
`;

export const DELETE_HUB = gql`
  mutation DeleteHub($id: Int!) {
    deleteHub(id: $id)
  }
`;

export const REMOVE_RADIUS = gql`
  mutation RemoveRadius($id: Int!) {
    removeHubRadius(id: $id)
  }
`;

export const CREATE_RADIUS = gql`
  mutation CreateRadius($data: HubRadiusInput!) {
    createHubRadius(data: $data) {
      id
      hub {
        id
      }
      name
      radiusStart
      radiusEnd
    }
  }
`;

export const UPDATE_RADIUS = gql`
  mutation UpdateRadius($data: HubRadiusInput!) {
    updateHubRadius(data: $data) {
      id
      hub {
        id
      }
      name
      radiusStart
      radiusEnd
    }
  }
`;

export const CREATE_HUB_ADDON_FARE = gql`
  mutation CreateHubAddonFare($data: HubAddonFareInput!) {
    createHubAddonFare(data: $data) {
      id
      hubId
      addon
      vehicleCategories
      price
    }
  }
`;

export const UPDATE_HUB_ADDON_FARE = gql`
  mutation UpdateHubAddonFare($data: HubAddonFareInput!) {
    updateHubAddonFare(data: $data) {
      id
      hubId
      addon
      vehicleCategories
      price
    }
  }
`;

export const REMOVE_HUB_ADDON_FARE = gql`
  mutation RemoveHubAddonFare($id: Int!) {
    removeHubAddonFare(id: $id)
  }
`;

export const HUB_DETAIL_TYPES = gql`
  query HubDetailTypes($data: HubDetailTypeInput!) {
    hubDetailTypes(data: $data) {
      results {
        name
        code
        options
        fixedOptions
      }
    }
  }
`;

export const HUB_VEHICLE_CONFIGURATIONS = gql`
  query HubVehicleConfigurations($id: Int!, $vehicleCategory: String) {
    hubVehicleConfigurations(id: $id, vehicleCategory: $vehicleCategory) {
      id
      hubId
      vehicleCategory
      maxPassengers
      minPassengers
      maxLuggage
      minBookWindowHours
      active
      minPassengersAdditional
      maxPassengersAdditional
      maxLuggageAdditional
    }
  }
`;

export const HUB_VEHICLE_CONFIGURATION = gql`
  query HubVehicleConfiguration($id: Int!, $vehicleCategory: String) {
    hubVehicleConfiguration(id: $id, vehicleCategory: $vehicleCategory) {
      id
      hubId
      vehicleCategory
      maxPassengers
      minPassengers
      maxLuggage
      maxBoosterSeats
      maxCombinedBabyAndBoosterSeats
      maxLuggagePerPassenger
      active
      maxBabySeats
      maxChildSeats
      minBookWindowHours
      minFare
      minPassengersAdditional
      maxPassengersAdditional
      maxLuggageAdditional
      vehicleModelsConfiguration {
        vehicleModels
      }
    }
  }
`;

export const REMOVE_HUB_VEHICLE_CONFIGURATION = gql`
  mutation RemoveHubVehicleConfiguration($id: Int!) {
    removeHubVehicleConfiguration(id: $id)
  }
`;

export const UPDATE_HUB_VEHICLE_CONFIGURATION = gql`
  mutation UpdateHubVehicleConfiguration($data: HubVehicleConfigurationInput!) {
    updateHubVehicleConfiguration(data: $data) {
      id
      hubId
      vehicleCategory
      minPassengers
      maxPassengers
      maxLuggage
      maxBoosterSeats
      maxBabySeats
      minBookWindowHours
      maxLuggagePerPassenger
      active
      minFare
    }
  }
`;

export const CREATE_HUB_VEHICLE_CONFIGURATION = gql`
  mutation CreateHubVehicleConfiguration($data: HubVehicleConfigurationInput!) {
    createHubVehicleConfiguration(data: $data) {
      id
      hubId
      vehicleCategory
      minPassengers
      maxPassengers
      maxLuggage
      maxBoosterSeats
      maxBabySeats
      minBookWindowHours
      minFare
    }
  }
`;

export const GEO_ZONE_FARES = gql`
  query GeoZoneFares($vehicleConfigurationId: Int!) {
    geoZoneFares(vehicleConfigurationId: $vehicleConfigurationId) {
      id
      vehicleConfigurationId
      fareInbound
      fareInboundChild
      fareOutboundChild
      fareInboundInfant
      fareOutboundInfant
      fareOutbound
      geoZone {
        id
        managedExternally
        name
      }
      fareDateLimitations {
        fromDateTime
        toDateTime
        fareDateLimitationType 
      }
    }
    hubVehicleConfiguration(id: $vehicleConfigurationId) {
      id
      hubId
      vehicleCategory
      hub {
        name
        currencyCode     
        geoZones {
          results {
            id
            name
          }
        }
      }
    }
  }
`;

export const CREATE_GEO_ZONE_FARE = gql`
  mutation CreateGeoZoneFare($data: GeoZoneFareInput!) {
    createGeoZoneFare(data: $data)
  }
`;

export const UPDATE_GEO_ZONE_FARE = gql`
  mutation UpdateGeoZoneFare($data: GeoZoneFareInput!) {
    updateGeoZoneFare(data: $data)
  }
`;

export const REMOVE_ALL_GEO_ZONE_FARES = gql`
  mutation RemoveAllGeoZoneFares($vehicleConfigurationId: Int!) {
    removeAllGeoZoneFares(vehicleConfigurationId: $vehicleConfigurationId)
  }
`;

export const RADIUS_FARES = gql`
  query RadiusFares($vehicleConfigurationId: Int!, $hubId: Int!) {
    radiusFares(vehicleConfigurationId: $vehicleConfigurationId) {
      id
      radius {
        id
        radiusStart
        radiusEnd
      }
      startFareInbound
      startFareOutbound
      farePerUnitInbound
      farePerUnitOutbound
    }
    hub(id: $hubId) {
      measurementSystem
      currencyCode
    }
  }
`;

export const RADIUS_FARE = gql`
  query RadiusFare($id: Int!, $hubId: Int!) {
    radiusFare(id: $id) {
      id
      radius {
        id
        radiusStart
        radiusEnd
      }
      startFareInbound
      startFareOutbound
      farePerUnitInbound
      farePerUnitOutbound
    }
  }
`;

export const CREATE_RADIUS_FARE = gql`
  mutation CreateRadiusFare($data: RadiusFareInput!) {
    createRadiusFare(data: $data) {
      id
      radius {
        id
        radiusStart
        radiusEnd
      }
      startFareInbound
      startFareOutbound
      farePerUnitInbound
      farePerUnitOutbound
    }
  }
`;

export const UPDATE_RADIUS_FARE = gql`
  mutation UpdateRadiusFare($data: RadiusFareInput!) {
    updateRadiusFare(data: $data) {
      id
      radius {
        id
        radiusStart
        radiusEnd
      }
      startFareInbound
      startFareOutbound
      farePerUnitInbound
      farePerUnitOutbound
    }
  }
`;

export const REMOVE_GEO_ZONE_FARE = gql`
  mutation RemoveGeoZoneFare($id: Int!) {
    removeGeoZoneFare(id: $id)
  }
`;

export const REMOVE_RADIUS_FARE = gql`
  mutation RemoveRadiusFare($id: Int!) {
    removeRadiusFare(id: $id)
  }
`;

export const REMOVE_ALL_RADIUS_FARES = gql`
  mutation RemoveAllRadiusFares($vehicleConfigurationId: Int!) {
    removeAllRadiusFares(vehicleConfigurationId: $vehicleConfigurationId)
  }
`;

export const ZIP_CODE_GROUP_LIST = gql`
  query ZipCodeGroups($hubId: Int!) {
    zipCodeGroups(hubId: $hubId) {
      id
      hubId
      name
    }
  }
`;

export const ZIP_CODE_GROUP = gql`
  query ZipCodeGroup($id: Int!) {
    zipCodeGroup(id: $id) {
      id
      hubId
      name
    }
  }
`;

export const REMOVE_ZIP_CODE_GROUP = gql`
  mutation RemoveZipCodeGroup($id: Int!) {
    removeZipCodeGroup(id: $id)
  }
`;

export const UPDATE_DISTANCE_FARE = gql`
  mutation UpdateDistanceFare($data: DistanceFareInput!) {
    updateDistanceFare(data: $data) {
      id
      vehicleConfigurationId
      startFareInbound
      startFareOutbound
      farePerUnitInbound
      farePerUnitOutbound
  }
}
`;

export const DISTANCE_FARE = gql`
  query DistanceFare($vehicleConfigurationId: Int!) {
    distanceFare(vehicleConfigurationId: $vehicleConfigurationId) {
      id
      vehicleConfigurationId
      startFareInbound
      startFareOutbound
      farePerUnitInbound
      farePerUnitOutbound
    }
  }
`;

export const UPDATE_ZIP_CODE_GROUP = gql`
  mutation UpdateZipCodeGroup($data: ZipCodeGroupInput!) {
    updateZipCodeGroup(data: $data) {
      id
      hubId
      name
    }
  }
`;

export const CREATE_ZIP_CODE_GROUP = gql`
  mutation CreateZipCodeGroup($data: ZipCodeGroupInput!) {
    createZipCodeGroup(data: $data) {
      id
      hubId
      name
    }
  }
`;

export const ZIP_CODE_FARES = gql`
  query ZipCodeFareList($vehicleConfigurationId: Int!, $hubId: Int!) {
    zipCodeFares(vehicleConfigurationId: $vehicleConfigurationId) {
      id
      vehicleConfigurationId
      zipCodeGroupId
      zipCodeGroupName
      fareInbound
      fareOutbound
    }
    zipCodeGroups(hubId: $hubId) {
      id
      hubId
      name
    }
    hub(id: $hubId) {
      currencyCode
    }
  }
`;

export const CREATE_ZIP_CODE_FARE = gql`
  mutation CreateZipCodeFare($data: ZipCodeFareInput!) {
    createZipCodeFare(data: $data) {
      id
      vehicleConfigurationId
      zipCodeGroupId
      zipCodeGroupName
      fareInbound
      fareOutbound
    }
  }
`;

export const UPDATE_ZIP_CODE_FARE = gql`
  mutation UpdateZipCodeFare($data: ZipCodeFareInput!) {
    updateZipCodeFare(data: $data) {
      id
      vehicleConfigurationId
      zipCodeGroupId
      zipCodeGroupName
      fareInbound
      fareOutbound
    }
  }
`;

export const REMOVE_ALL_ZIP_CODE_FARES = gql`
  mutation RemoveAllZipCodeFares($vehicleConfigurationId: Int!) {
    removeAllZipCodeFares(vehicleConfigurationId: $vehicleConfigurationId)
  }
`;

export const NUMERIC_ZIP_CODE_RANGES = gql`
  query NumericZipCodeRanges($zipCodeGroupId: Int!) {
    numericZipCodeRanges(zipCodeGroupId: $zipCodeGroupId) {
      id
      zipCodeGroupId
      rangeFrom
      rangeTo
    }
  }
`;

export const REMOVE_ZIP_CODE_FARE = gql`
  mutation RemoveZipCodeFare($id: Int!) {
    removeZipCodeFare(id: $id)
  }
`;

export const HUB_FARE_SURCHARGES = gql`
  query FareSurcharges($hubId: Int!, $day: String, $from: String, $till: String, $sort: String) {
    weekDayFareSurcharges(hubId: $hubId, day: $day) {
      id
      hubId
      amount
      vehicleCategories
      percentage
      days
      timeFrom
      timeTill
    }

    dateRangeFareSurcharges(hubId: $hubId, from: $from, till: $till, sort: $sort) {
      id
      hubId
      amount
      vehicleCategories
      percentage
      dateFrom
      dateTill
    }
  }
`;

export const CREATE_HUB_DATE_RANGE_FARE_SURCHARGE = gql`
  mutation CreateDateRangeFareSurcharge($data: DateRangeFareSurchargeInput!) {
    createDateRangeFareSurcharge(data: $data) {
      id
      hubId
      percentage
      dateFrom
      dateTill
    }
  }
`;

export const UPDATE_HUB_DATE_RANGE_FARE_SURCHARGE = gql`
  mutation UpdateDateRangeFareSurcharge($data: DateRangeFareSurchargeInput!) {
    updateDateRangeFareSurcharge(data: $data) {
      id
      hubId
      percentage
      dateFrom
      dateTill
    }
  }
`;

export const REMOVE_HUB_DATE_RANGE_FARE_SURCHARGE = gql`
  mutation RemoveDateRangeFareSurcharge($id: Int!) {
    removeDateRangeFareSurcharge(id: $id)
  }
`;

export const CREATE_HUB_WEEKDAY_FARE_SURCHARGE = gql`
  mutation CreateWeekDayFareSurcharge($data: WeekDayFareSurchargeInput!) {
    createWeekDayFareSurcharge(data: $data) {
      id
      hubId
      percentage
      days
      timeFrom
      timeTill
    }
  }
`;

export const UPDATE_HUB_WEEKDAY_FARE_SURCHARGE = gql`
  mutation UpdateWeekDayFareSurcharge($data: WeekDayFareSurchargeInput!) {
    updateWeekDayFareSurcharge(data: $data) {
      id
      hubId
      percentage
      days
      timeFrom
      timeTill
    }
  }
`;

export const REMOVE_HUB_WEEKDAY_FARE_SURCHARGE = gql`
  mutation RemoveWeekDayFareSurcharge($id: Int!) {
    removeWeekDayFareSurcharge(id: $id)
  }
`;
export const REMOVE_NUMERIC_ZIP_CODE_RANGE = gql`
  mutation RemoveNumericZipCodeRange($id: Int!) {
    removeNumericZipCodeRange(id: $id)
  }
`;

export const STARTS_WITH_ZIP_CODE_RANGES = gql`
  query StartsWithZipCodeRanges($zipCodeGroupId: Int!) {
    startsWithZipCodeRanges(zipCodeGroupId: $zipCodeGroupId) {
      id
      zipCodeGroupId
      startsWithValue
    }
  }
`;

export const REMOVE_STARTS_WITH_ZIP_CODE_RANGE = gql`
  mutation RemoveStartsWithZipCodeRange($id: Int!) {
    removeStartsWithZipCodeRange(id: $id)
  }
`;
export const CREATE_STARTS_WITH_ZIP_CODE_RANGE = gql`
  mutation CreateStartsWithZipCodeRange($data: StartsWithZipCodeRangeInput!) {
    createStartsWithZipCodeRange(data: $data) {
      id
      zipCodeGroupId
      startsWithValue
    }
  }
`;

export const UPDATE_STARTS_WITH_ZIP_CODE_RANGE = gql`
  mutation UpdateStartsWithZipCodeRange($data: StartsWithZipCodeRangeInput!) {
    updateStartsWithZipCodeRange(data: $data) {
      id
      zipCodeGroupId
      startsWithValue
    }
  }
`;

export const CREATE_NUMERIC_ZIP_CODE_RANGE = gql`
  mutation CreateNumericZipCodeRange($data: NumericZipCodeRangeInput!) {
    createNumericZipCodeRange(data: $data) {
      id
      zipCodeGroupId
      rangeFrom
      rangeTo
    }
  }
`;

export const UPDATE_NUMERIC_ZIP_CODE_RANGE = gql`
  mutation UpdateNumericZipCodeRange($data: NumericZipCodeRangeInput!) {
    updateNumericZipCodeRange(data: $data) {
      id
      zipCodeGroupId
      rangeFrom
      rangeTo
    }
  }
`;

export const GEO_ZONES = gql`
  query GeoZones($hubId: Int!) {
    geoZones(hubId: $hubId) {
      id
      name
      hubId
      polygon {
        lat
        lng
      }
    }
    hub(id: $hubId) {
      currencyCode
      position {
        lat
        lng
      }
    }
    hubVehicleConfigurations(id: $hubId) {
      vehicleCategory
      geoZoneFares {
        fareInbound
        fareOutbound
        geoZoneId
      }
    }
  }
`;

export const GEO_ZONE_BY_ID = gql`
  query GeoZone($id: Int!) {
    geoZone(id: $id) {
      id
      name
      hubId
      polygon {
        lat
        lng
      }
    }
  }
`;

export const SEARCH_GEO_ZONES = gql`
  query SearchGeoZones($page: Int!, $size: Int!, $hubId: Int!, $managedExternally: Boolean) {
    searchGeoZones(page: $page, size: $size, hubId: $hubId, managedExternally: $managedExternally) {
      results {
        id
        name
        hubId
        managedExternally
        externalReference
        polygon {
          lat
          lng
        }
      }
      pagination {
        currentPage
        pageSize
        totalPages
        totalResults
      }
    }
    hub(id: $hubId) {
      currencyCode
      id
      position {
        lat
        lng
      }
    }
    hubVehicleConfigurations(id: $hubId) {
      vehicleCategory
      geoZoneFares {
        fareInbound
        fareOutbound
        geoZoneId
      }
    }
  }
`;

export const SEARCH_GEO_ZONES_BY_FLEET = gql`
  query SearchGeoZonesByFleet($hubIds: [Int!]) {
    searchGeoZonesByFleet(hubIds: $hubIds) {
      results {
        id
        name
        hubId
        managedExternally
        externalReference
        polygon {
          lat
          lng
        }
      }
      pagination {
        currentPage
        pageSize
        totalPages
        totalResults
      }
    }
  }
`;

export const CREATE_GEO_ZONE = gql`
  mutation CreateGeoZone($data: GeoZoneInput!) {
    createGeoZone(data: $data)
  }
`;

export const UPDATE_GEO_ZONE = gql`
  mutation UpdateGeoZone($data: GeoZoneInput!) {
    updateGeoZone(data: $data)
  }
`;

export const REMOVE_GEO_ZONE = gql`
  mutation RemoveGeoZone($id: Int!) {
    removeGeoZone(id: $id)
  }
`;

export const MEETING_POINTS = gql`
  query HubMeetingPoints($hubId: Int!) {
    hubMeetingPoints(hubId: $hubId) {
      id
      hubId
      title
      description
      active
      mapFileId
      meetingPointFiles {
       file {
        externalKey
        contentType
        displayName
       }
       fileType
       fileId
      }
      geographicLocation {
        lat
        lng
      }
      mapFile {
        externalKey
        contentType
      }
    }
  }
`;

export const REMOVE_MEETING_POINT = gql`
  mutation RemoveHubMeetingPoint($id: Int!) {
    removeHubMeetingPoint(id: $id)
  }
`;

export const REMOVE_MEETING_POINT_IMAGE = gql`
  mutation RemoveMeetingPointImage($id: Int!, $fileId: Int!) {
    removeMeetingPointImage(id: $id, fileId: $fileId)
  }
`;

export const CREATE_MEETING_POINT = gql`
  mutation CreateHubMeetingPoint($data: HubMeetingPointInput!) {
    createHubMeetingPoint(data: $data) {
      id
    }
  }
`;

export const UPDATE_MEETING_POINT = gql`
  mutation UpdateHubMeetingPoint($data: HubMeetingPointInput!) {
    updateHubMeetingPoint(data: $data) {
      id
    }
  }
`;

export const HUB_TENDERS = gql`
  query HubTenders($data: HubTendersParamsInput!, $skip: Boolean!) {
    hubTenders(data: $data) @skip(if: $skip) {
      results {
        id
        hubId
        hubName
        autoAccept
        hub {
          overrideJourneysDistributionDefaultPercentages
        }
        preferred
        journeysDistributionPercentage
        fleet {
          id
          name
          active
          acceptNewRides
          availableVehicleCategories
        }
        vehicleCategories
        fleetId
        transferCompanies {
          results {
            id
            postalAddress {
              companyName
            }
          }
        }
        vehicles {
          results {
            categories
          }
        }
        bookingWindows {
          results {
            type
            numberOfHoursInbound
            numberOfHoursOutbound
            vehicleCategory
          }
        }
        meetingPoints {
          results {
            id
            title
            description
            geographicLocation {
              lat
              lng
            }
          }
        }
      }
      pagination {
        currentPage
        pageSize
        totalPages
        totalResults
      }
    }
  }
`;

export const HUB_TENDERS_MATCHES = gql`
  mutation HubTendersMatches($data: HubTendersMatchesRequestParams!) {
    hubTendersMatches(data: $data) {
      fleet {
        id
        name
      }
      transferCompany {
        id
        organization {
          name
        }
      }
      fleetId
      transferCompanyId
      status
    }
  }
`;

export const SINGLE_UPLOAD = gql`
  mutation($id: Int!, $file: Upload!) {
    uploadMeetingPointMapImage(id: $id, file: $file)
  }
`;

export const SINGLE_UPLOAD_IMAGE = gql`
  mutation($id: Int!, $file: Upload!, $fileType: String!) {
    uploadMeetingPointImage(id: $id, file: $file, fileType: $fileType)
  }
`;

export const CREATE_HUB_TENDER = gql`
  mutation CreateHubTender($data: HubTenderInput!) {
    createHubTender(data: $data) {
        id
    }
  }
`;

export const HUB_TENDER_DETAILS = gql`
  query HubTenderDetails($id: Int!) {
    hubTender(id: $id) {
      id
      hubId
      hub {
        id
        position {
          lat
          lng
        }
        overrideJourneysDistributionDefaultPercentages
      }
      hubName
      fleetId
      preferred
      autoAccept
      vehicleCategories
      fleet {
        transferCompanyId
        name
        transferCompany {
          id
          name
        }
      }
    }
  }
`;

export const UPDATE_HUB_TENDER = gql`
  mutation UpdateHubTender($id: Int!, $data: HubTenderInput!) {
    updateHubTender(id: $id, data: $data)
  }
`;

export const DELETE_HUB_TENDER = gql`
  mutation DeleteHubTender($id: Int!) {
    deleteHubTender(id: $id)
  }
`;

export const UPDATE_JOURNEY_DISTRIBUTION_PERCENTAGES = gql`
  mutation UpdateJourneyDistibutionPercentages($params: [JourneyDistributionPercentagesParams]!) {
    updateJourneyDistributionPercentages(params: $params)
  }
`;

export const TOGGLE_OVERRIDE_JOURNEYS_DISTRIBUTION_PERCENAGES = gql`
  mutation ToggleOverrideJourneysDistributionDefaultPercentages($id: Int!) {
    toggleOverrideJourneysDistributionDefaultPercentages(id: $id)
  }
`;

export const MULTILINGUAL_HUBS = gql`
  query MultilingualHubs($params: MultilingualHubsRequestParams!) {
    multilingualHubs(params: $params) {
      results {
        id
        name
        autoCompleteName
        autoCompleteLocation
        hubType
        position {
          lat
          lng
        }
        countryCode
        highlightedResult {
          autoCompleteName {
            value
          }
          autoCompleteLocation {
            value
          }
        }
      }
      pagination {
        currentPage
        pageSize
        totalPages
        totalResults
      }
    }
  }
`;

export const COPY_GEO_ZONES = gql`
  mutation CopyGeoZones($data: CopyGeoZonesParams!) {
    copyGeoZones(data: $data)
  }
`;

export const HUB_BOOKING_WINDOW_EXTENSIONS = gql`
  query HubBookingWindowExtenstions ($hubId: Int!) {
    hubBookingWindowExtensions(hubId: $hubId) {
      id
      extensionInMinutes
      rangeFrom
      rangeTo
    }
  }
`;

export const CREATE_HUB_BOOKING_WINDOW_EXTENSION = gql`
  mutation CreateHubBookingWindowExtenstion($data: BookingWindowExtensionParams!) {
    createHubBookingWindowExtension(data: $data)
  }
`;

export const UPDATE_HUB_BOOKING_WINDOW_EXTENSION = gql`
  mutation UpdateHubBookingWindowExtenstion($data: BookingWindowExtensionParams!) {
    updateHubBookingWindowExtension(data: $data)
  }
`;

export const REMOVE_HUB_BOOKING_WINDOW_EXTENSION = gql`
  mutation RemoveHubBookingWindowExtenstion($id: Int!) {
    removeHubBookingWindowExtension(id: $id)
  }
`;

export const VEHICLE_AVAILABILITY_LIMITATIONS = gql`
  query VehicleAvailabilityLimitations($hubId: Int!) {
    vehicleAvailabilityLimitations(hubId: $hubId) {
      id
      fromDay
      toDay
      fromMonth
      toMonth
      weekDays
      fromTime
      toTime
      vehicleCategories
      created
    }
  }
`;

export const REMOVE_VEHICLE_AVAILABILITY_LIMITATION = gql`
  mutation RemoveVehicleAvailabilityLimitation($id: Int!) {
    removeVehicleAvailabilityLimitation(id: $id)
  }
`;

export const CREATE_VEHICLE_AVAILABILITY_LIMITATION = gql`
  mutation CreateVehicleAvailabilityLimitation($params: VehicleAvailabilityLimitationParams!) {
    createVehicleAvailabilityLimitation(params: $params)
  }
`;

export const UPDATE_VEHICLE_AVAILABILITY_LIMITATION = gql`
  mutation UpdateVehicleAvailabilityLimitation($params: VehicleAvailabilityLimitationParams!) {
    updateVehicleAvailabilityLimitation(params: $params) {
      id
    }
  }
`;
